<template>
    <div class="d-flex align-center">
        <tool-tip :message="t('order.downloadReceipt')">
            <card-button
                density="comfortable"
                color="primary"
                min-width="0"
                :target="TARGET_TYPES.SELF"
                class="text-none rounded-xl px-3 ma-0"
                :link="generateOrderUrl()"
                data-id="orderHistoryItemMenuButton"
            >
                <SvgIcon :icon="receipt" alt="receipt" />
            </card-button>
        </tool-tip>
    </div>
</template>

<script setup lang="ts">
import { IOrderHistoryCardAction } from '../../types';
import { generateUrl } from '@/helpers';
import { useAppConfiguration } from '@/composables';
import { useI18n } from 'vue-i18n';
import SvgIcon from '@/features/common/components/SvgIcon.vue';
import CardButton from '@/features/common/components/CardButton.vue';
import receipt from '@/assets/receipt.svg';
import ToolTip from '@/features/common/components/ToolTip.vue';
import { TARGET_TYPES } from '@/constants';

const { t } = useI18n();
const { config, language } = useAppConfiguration();

const props = defineProps<IOrderHistoryCardAction>();

const generateOrderUrl = () => generateUrl(config.value.webshopBaseUrl, language.value, `orders/${props.orderId}`);
</script>
